import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../../services/adminApi';

// Note: Adjust the path to AuthLayout depending on your folder structure. 
// Based on your api import paths, it might be '../../components/auth/AuthLayout'
import AuthLayout from '../../components/auth/AuthLayout';

// Make sure to import the CSS file where your custom classes are defined 
// (e.g., .btn-auth-primary, .form-ctrl-login-custom)
import './AdminLogin.css'; 

const AdminLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        
        try {
            const res = await adminLogin({ email, password });
            localStorage.setItem('adminToken', res.data.token);
            navigate('/admin/dashboard');
        } catch (err) {
            setError(err.response?.data?.message || 'Invalid admin credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout
            pageTitle="Admin Login"
            sidebarTitle="Admin Portal"
            subtitle="Sign in to the admin dashboard to continue"
             className="admin-login-auth-layout" 
        >
            {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}
            
            <Form onSubmit={handleLogin}>
                <Form.Group className="mb-3">
                    <Form.Label className="form-label-custom">Email Address</Form.Label>
                    <Form.Control 
                        type="email" 
                        placeholder="admin@example.com" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        required 
                        className="form-ctrl-login-custom" 
                    />
                </Form.Group>
                
                <Form.Group className="mb-4">
                    <Form.Label className="form-label-custom">Password</Form.Label>
                    <Form.Control 
                        type="password" 
                        placeholder="••••••••" 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)} 
                        required 
                        className="form-ctrl-login-custom" 
                    />
                </Form.Group>

                <Button 
                    type="submit" 
                    className="btn-auth-primary w-100 mt-2" 
                    disabled={loading}
                    style={{marginBottom:'30px'}}
                >
                    {loading ? 'Signing in...' : 'Sign In as Admin'}
                </Button>
            </Form>
        </AuthLayout>
    );
};

export default AdminLogin;